import { PROVIDER_ROSTER_STATUS_SELECT } from 'utils/constants/tables/staff';

export const ROSTER_SAVE_ERROR = 'Could not save the staff change. Try again.';

type RosterRow = { providerId?: number; [field: string]: any };

/**
 * Builds the UPDATE_PROVIDER payload for an inline roster edit.
 * Only the edited field is sent (plus id, and email which the input type
 * requires), so the save cannot overwrite fields edited elsewhere since the
 * roster loaded, and leaves assistants alone.
 */
export const buildRosterProviderUpdate = (
  providerInfo: { id: number; email: string },
  updateType: string,
  updatedField: any
) => {
  const provider: Record<string, any> = {
    id: providerInfo.id,
    email: providerInfo.email,
    [updateType]: updatedField
  };
  if (updateType === 'status') {
    const [activeMap] = PROVIDER_ROSTER_STATUS_SELECT;
    provider.isActive = updatedField === activeMap.value;
  }
  return provider;
};

const setRowField = (
  rows: RosterRow[],
  providerId: number,
  field: string,
  value: any
) =>
  rows.map(row =>
    row.providerId === providerId ? { ...row, [field]: value } : row
  );

/**
 * Shows the edit in the row straight away, then saves it. If the save fails
 * the row goes back to its previous value and onError is called.
 */
export const saveRosterEdit = async ({
  providerId,
  updateType,
  updatedField,
  setTableData,
  save,
  onError
}: {
  providerId: number;
  updateType: string;
  updatedField: any;
  setTableData: (update: (rows: RosterRow[]) => RosterRow[]) => void;
  save: () => Promise<unknown>;
  onError: (error: unknown) => void;
}) => {
  let previousValue: any;
  setTableData(rows => {
    const row = rows.find(r => r.providerId === providerId);
    previousValue = row?.[updateType];
    return setRowField(rows, providerId, updateType, updatedField);
  });
  try {
    await save();
  } catch (error) {
    setTableData(rows =>
      setRowField(rows, providerId, updateType, previousValue)
    );
    onError(error);
  }
};
